import React from 'react';
import cn from 'classnames';
import s from './CoreStar.scss';
var CoreStar = function (_a) {
    var className = _a.className, size = _a.size, customSize = _a.customSize, _b = _a.corePackage, corePackage = _b === void 0 ? 'core_access' : _b;
    return (React.createElement("div", { className: cn(s['root'], s[corePackage], size && !customSize && s["size-" + size], className), style: customSize },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15" },
            React.createElement("path", { d: "M0 7.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z", fill: "inherit" }),
            React.createElement("path", { d: "m7.5 2.778 1.26 2.796 2.967.37-2.19 2.1.575 3.025L7.5 9.57l-2.612 1.5.575-3.026-2.19-2.1 2.968-.37L7.5 2.778Z", fill: "#FFFFFF" }))));
};
CoreStar.displayName = 'CoreStar';
export default CoreStar;
//# sourceMappingURL=CoreStar.js.map